import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d062d6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-box"
};
const _hoisted_2 = {
  class: "search-warp"
};
import { reactive } from 'vue';
import router from '@/router';
export default {
  __name: 'index',
  setup(__props) {
    const state = reactive({
      searchStr: '',
      isFoucus: false
    });
    // 选中输入框
    const inputFoucus = flag => {
      state.isFoucus = flag;
    };
    const doSearch = () => {
      router.push({
        path: '/course',
        query: {
          searchStr: state.searchStr
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        type: "text",
        class: "search-input",
        modelValue: state.searchStr,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.searchStr = $event),
        onFocus: _cache[1] || (_cache[1] = $event => inputFoucus(true)),
        onBlur: _cache[2] || (_cache[2] = $event => inputFoucus(false)),
        onKeyup: _withKeys(doSearch, ["enter"]),
        placeholder: "请输入关键字",
        clearable: ""
      }, null, 8, ["modelValue", "onKeyup"]), _createVNode(_component_Icon, {
        name: "el-icon-Search",
        class: "search-icon",
        cursor: "",
        onClick: _cache[3] || (_cache[3] = $event => doSearch())
      })])]);
    };
  }
};